import React from "react";
import { func, bool } from "prop-types";
import moment from "moment";
import I18n from "pages/_components/I18n";
import { getLimitDate } from "util/date";
import FilterForm from "pages/debinPayments/_components/FilterForm";

const EmitedSideBarForm = ({ closeSidebar, isReceived, isRecurrent, isEmited, isScheduled }) => {
    const dateFrom = getLimitDate(-184);
    const dateTo = moment().toDate();

    const createdFrom = getLimitDate(-184);
    const createdTo = getLimitDate(7);

    const initialValues = {
        dateRange: [dateFrom, dateTo],
        dateRangeRecurrency: [createdFrom, createdTo],
        dateRangeScheduled: [dateFrom, dateTo],
    };

    return (
        <div className="container full-width">
            <div className="mb-4 f-weight-b">
                <I18n id="debin.filter" component="h2" />
            </div>
            <div className="text-left">
                <FilterForm
                    isEmittedForm
                    customValues={initialValues}
                    closeSidebar={closeSidebar}
                    isReceived={isReceived}
                    isRecurrent={isRecurrent}
                    isEmited={isEmited}
                    isScheduled={isScheduled}
                />
            </div>
        </div>
    );
};

EmitedSideBarForm.propTypes = {
    closeSidebar: func.isRequired,
    isReceived: bool,
    isRecurrent: bool,
    isEmited: bool,
    isScheduled: bool,
};
EmitedSideBarForm.defaultProps = {
    isReceived: false,
    isRecurrent: false,
    isEmited: false,
    isScheduled: false,
};
export default EmitedSideBarForm;
